module.exports = __webpack_public_path__ + "static/media/cc-cvc.b5f8f52b.svg";